<div class="my-places-screen" *transloco="let t">
  <div class="limited-offer-details-container">
    <span class="limited-offer-title"> {{t('limitedOffers.title')}}</span>
    <app-limited-offers-carousel [campaigns]="limitedOfferCampaigns()"></app-limited-offers-carousel>
  </div>

  <mat-divider class="my-places-divider"></mat-divider>

  <div class="campaigns-list-container1">
    <app-campaign-with-loyalty-list></app-campaign-with-loyalty-list>
  </div>
</div>
